import { CAURL } from "../../../routes/ca_routes/CAURL";

export const sidebarItems = [
    { icon: "home", title: "Dashboard", path: CAURL.CA_DASHBOARD },
    // { icon: "users", title: "Clients & Businesses", path: CAURL.CA_ALL_CLIENTS },
    // { icon: "invoice", title: "Invoices", path: CAURL.CA_ALL_CLIENTS_INVOICES },
    // { icon: "document", title: "Document Requests", path: CAURL.CA_NOTIFICATIONS_MANAGEMENT },

    {
        icon: "users",
        title: "Clients",
        children: [
            {
                icon: "building2",
                title: "Clients & Businesses",
                path: CAURL.CA_ALL_CLIENTS,
            },
            {
                icon: "invoice",
                title: "Invoices",
                path: CAURL.CA_ALL_CLIENTS_INVOICES,
            },
            {
                icon: "fileText",
                title: "Document Requests",
                path: CAURL.CA_NOTIFICATIONS_MANAGEMENT,
            },
        ],
    },

    {
        icon: "userCog",
        title: "Team",
        children: [
            {
                icon: "layoutDashboard",
                title: "Dashboard",
                path: CAURL.CA_TEAMS_DASHBOARD,
            },
            { icon: "user", title: "Team Management", path: CAURL.CA_ALL_TEAMS },
            { icon: "user", title: "Employees", path: CAURL.CA_TEAMS_EMPLOYEES },
            { icon: "listChecks", title: "Tasks", path: CAURL.CA_TEAMS_TASKS },
            {
                icon: "calendarDays",
                title: "Calendar",
                path: CAURL.CA_TEAMS_CALENDAR,
            },
            { icon: "activity", title: "Activity", path: CAURL.CA_TEAMS_ACTIVITY },
        ],
    },

    {
        icon: "officeEmployee",
        title: "Firm",
        children: [
            { icon: "building", title: "Overview", path: CAURL.CA_FIRM_OVERVIEW },
            {
                icon: "network",
                title: "Departments",
                path: CAURL.CA_FIRM_DEPARTMENTS,
            },
            { icon: "building2", title: "Offices", path: CAURL.CA_FIRM_OFFICES },
            {
                icon: "shieldCheck",
                title: "Roles & Permissions",
                path: CAURL.CA_FIRM_ROLES,
            },
            // { title: "Members",          path: CAURL.CA_FIRM_MEMBERS },
            // { title: "Settings",         path: CAURL.CA_FIRM_SETTINGS },
        ],
    },

    {
        icon: "wallet",
        title: "Finance",
        children: [
            {
                icon: "chartNoAxesCombined",
                title: "Dashboard",
                path: CAURL.CA_FINANCE_DASHBOARD,
            },
            {
                icon: "bookOpen",
                title: "Books & Ledgers",
                path: CAURL.CA_FINANCE_BOOKS_LEDGERS,
            },
            {
                icon: "bookMarked",
                title: "Journal Entries",
                path: CAURL.CA_FINANCE_JOURNAL_ENTRIES,
            },
            {
                icon: "ticketCheck",
                title: "Vouchers",
                path: CAURL.CA_FINANCE_VOUCHERS,
            },
            {
                icon: "creditCard",
                title: "Client Payments",
                path: CAURL.CA_FINANCE_CLIENT_PAYMENTS_PAGE,
                activeRoutes: [
                    CAURL.CA_FINANCE_CLIENT_PAYMENTS_PAGE,
                    CAURL.CA_FINANCE_EDIT_CLIENT_PAYMENTS_PAGE,
                    CAURL.CA_FINANCE_SHOW_ALL_CLIENT_PAYMENT_REQUESTS_PAGE,
                ]
            },
            {
                icon: "trendingUp",
                title: "Firm Earnings",
                path: CAURL.CA_FINANCE_FIRM_EARNINGS,
            },
        ],
    },

    // {
    //     icon: "document",
    //     title: "Reports",
    //     children: [
    //         { title: "Overview",    path: CAURL.CA_REPORT_OVERVIEW },
    //         { title: "Employees",   path: CAURL.CA_REPORT_EMPLOYEES },
    //         { title: "Departments", path: CAURL.CA_REPORT_DEPARTMENTS },
    //         { title: "Firm",        path: CAURL.CA_REPORT_FIRM },
    //         { title: "Exports",     path: CAURL.CA_REPORT_EXPORT },
    //     ],
    // },

    // {
    //     icon: "invoice",
    //     title: "GST",
    //     children: [
    //         { title: "Dashboard", path: CAURL.CA_GST_DASHBOARD },
    //         { title: "Returns",   path: CAURL.CA_GST_RETURNS },
    //         { title: "Exports",   path: CAURL.CA_GST_EXPORTS },
    //         { title: "History",   path: CAURL.CA_GST_HISTORY },
    //     ],
    // },

    { icon: "settings", title: "Platform Settings", path: CAURL.CA_SETTINGS },
];
